import React, { useCallback, useState } from 'react'
import { ChildrenGraphStyles, WrapGraph, WrapIcon, WrapNumChild, WrapGraphTexts, GraphNumber, WrapGraphItem, WrapChild, LineStyles, DraggableStyles } from './Style'
import { Progress } from 'components/Record'
import { FlexCenter } from 'styles/GlobalStyle'
import { isEmpty, uniqBy } from 'lodash'
import { ratingColors, ratingColors2, ratingColors3, ratingText } from 'keys/rating'
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragOverlay, } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, } from '@dnd-kit/sortable';
import { BarLine, BarTexts, statsBarHooks } from '.'
import { Draggable, BarItem, DraggableItem } from '.'
import { gray } from 'styles/theme'

const StatsBar = (props) => {
    const { checkType, batItemWidth = 5, hideBarText, type = "bar", draggable, handleOnDragEnd, showArrows, setShowStartBar, setShowEndBar, showEndBar, showStartBar = true, sourceStats, stats, fullWidth, graphKey, isDrag, showFooter, viewItemCount, viewTestTaker, graphText, text, viewPercent, percent: isPercent, disabled } = props
    const [destination, setDestination] = useState(null);
    const [activeId, setActiveId] = useState(null);
    const isSlider = type == "slider"
    const isBar = type == "bar"

    const groupedStats = statsBarHooks.useStatsGroupedByRating(stats, showArrows, showStartBar, showEndBar);

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const sourceStatsEntries = Object.entries?.(sourceStats || {});
    const uniqueRatings = uniqBy(sourceStatsEntries, ([key, value]) => value.rating_id);// שימוש ב-Lodash כדי לשמור רק אובייקטים עם rating_id ייחודיים
    const ratingsObject = Object.fromEntries(uniqueRatings); // המרת המערך חזרה לאובייקט תוך שמירה על המפתחות

    const handleDragStart = useCallback((event) => {
        setActiveId(event.active.id);
    }, []);

    const handleDragMove = useCallback((event) => {
        setDestination(event.over.id)
    }, []);

    return (
        <ChildrenGraphStyles isSlider={isSlider} fullWidth={fullWidth} isDrag={isDrag}>
            <BarTexts
                isDrag={isDrag}
                checkType={checkType}
                showFooter={showFooter}
                text={text}
                hideBarText={hideBarText}
                isBar={isBar}
                isPercent={isPercent}
            />
            <div className='wrap-bar'>
                <DndContext sensors={sensors}
                    collisionDetection={closestCenter}
                    onDragStart={handleDragStart}
                    onDragMove={handleDragMove}
                    onDragEnd={(val) => {
                        handleOnDragEnd(val)
                        setActiveId(null)
                    }}
                >
                    <WrapGraph showFooter={showFooter} disabled={disabled}
                    >

                        {stats == "No Data" ?
                            <div className='no-data'>אין נתונים</div> :
                            !isEmpty(stats) ? Object.keys(groupedStats).reverse().map((rating, ratingIndex) => {
                                const ratingItems = groupedStats?.[rating]
                                const { items, count, percent, rating_index } = ratingItems

                                const textColor = ratingText[rating_index - 1]
                                const color = ratingColors[rating - 1]
                                const lightColor = ratingColors3[ratingIndex]
                                const prevColor = ratingColors[rating]
                                const prevLightColor = ratingColors3?.[ratingIndex - 1]

                                return (
                                    <>
                                        <span className='wrap-rating-group'>
                                            <span className='wrap-rating-group2'>
                                                <SortableContext items={items}>
                                                    {items?.map((item, index) => {
                                                        const { key, percent, count, current_test_taker } = item
                                                        const isSourceItem = ratingsObject[key] && (rating != 5 || index != 0)

                                                        const theme = {
                                                            textColor, prevColor, lightColor, isDrag, isSourceItem, prevLightColor,
                                                            color: item.rating_id ? color : null,
                                                            firstItem: ratingIndex == 0 && index == 0,
                                                            lastItem: ratingIndex == 4 && items.length - 1 == index,
                                                            firstRatingItem: ratingIndex != 0 && index == 0
                                                        }

                                                        let itemWidth = 42
                                                        if (isSlider && index > 0 && !theme.firstItem && !ratingsObject[key])
                                                            itemWidth = batItemWidth

                                                        return (
                                                            <>
                                                                {showArrows && isBar && theme.firstItem &&
                                                                    <div className='arrow'>
                                                                        <BarItem size="large" bold onClick={setShowStartBar} theme={theme} value={showStartBar ? ">" : "<"} />
                                                                    </div>
                                                                }

                                                                <Draggable fullWidth={fullWidth} key={key.toString()} id={key.toString()}
                                                                    isDraggable={isDrag && index == 0 && !theme.firstItem}>
                                                                    <DraggableStyles fullWidth={fullWidth} itemWidth={itemWidth}>
                                                                        {
                                                                            draggable &&
                                                                            <div className='draggable-item'>
                                                                                <span className='draggable-item2'>
                                                                                    <div className='draggable-item3'>
                                                                                        <DraggableItem
                                                                                            percent={isPercent}
                                                                                            theme={theme}
                                                                                            showChildren={isBar}
                                                                                            hide={!(!index && !theme.firstItem)}
                                                                                            color={textColor}
                                                                                            colors={[color, color, prevColor, prevColor]}
                                                                                            value={key}
                                                                                        />
                                                                                    </div>
                                                                                </span>
                                                                            </div>
                                                                        }

                                                                        {isBar &&
                                                                            <BarItem
                                                                                viewTestTaker={viewTestTaker}
                                                                                viewPercent={viewPercent}
                                                                                index={index}
                                                                                theme={theme}
                                                                                value={key}
                                                                                current_test_taker={current_test_taker}
                                                                                percent={percent}
                                                                                count={count}
                                                                                isDrag={isDrag}
                                                                                graphKey={graphKey}
                                                                                viewItemCount={viewItemCount}
                                                                                isPercent={isPercent}
                                                                            />}
                                                                    </DraggableStyles>
                                                                </Draggable>

                                                                {showArrows && isBar && theme.lastItem &&
                                                                    <div className='arrow'>
                                                                        <BarItem size="large" bold onClick={setShowEndBar} theme={theme} value={showEndBar ? " <" : " >"} />
                                                                    </div>
                                                                }

                                                                {isSourceItem &&
                                                                    <div className='source-item'>
                                                                        <div className='source-item2' style={{
                                                                            position: "absolute",
                                                                            right: 11,
                                                                            zIndex: 2
                                                                        }}>
                                                                            <DraggableItem
                                                                                // percent={isPercent}
                                                                                theme={theme}
                                                                                showChildren={isBar}
                                                                                zIndex={250}
                                                                                color={gray}
                                                                                hide={!(!index && !theme.firstItem) && !isSourceItem}
                                                                                colors={[ratingColors2[ratingsObject[key].rating_index - 1], ratingColors2[ratingsObject[key].rating_index - 1], ratingColors2[ratingsObject[key].rating_index], ratingColors2[ratingsObject[key].rating_index]]}
                                                                                value={key}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                }
                                                            </>
                                                        )
                                                    })}
                                                </SortableContext>
                                            </span>
                                            {isSlider &&
                                                <BarLine
                                                    color={color}
                                                    count={count}
                                                    percent={percent}
                                                    ratingIndex={ratingIndex}
                                                />
                                            }
                                        </span>
                                    </>
                                )
                            }) :
                                <FlexCenter>
                                    <Progress />
                                </FlexCenter>
                        }
                        {activeId &&
                                                        <DragOverlay>
                                                            {/* <div style={{ position: 'relative', bottom: 323, right: 20 }}> */}
                                                            <DraggableItem
                                                                percent={isPercent}
                                                                showChildren={isBar}
                                                                color={ratingText[stats[activeId].rating_index - 1]}
                                                                colors={[ratingColors[stats[activeId].rating_index - 1], ratingColors[stats[activeId].rating_index - 1], ratingColors[stats[activeId].rating_index], ratingColors[stats[activeId].rating_index]]}
                                                                value={destination || activeId}
                                                            />
                                                            {/* </div> */}
                                                        </DragOverlay>
                                                    }
                    </WrapGraph >
                </DndContext>
            </div>
        </ChildrenGraphStyles >
    )
}

export default StatsBar